<section class="workspace" [class.workspace--dark]="darkMode()">
  <div class="workspace__shell">
    <app-navbar [appName]="'app.name' | translate" [moduleName]="'admin.moduleName' | translate"
      [moduleBadge]="'navbar.module3' | translate" logoutLink="/" [darkMode]="darkMode()"
      [language]="translationService.language()" [languages]="languages" (themeToggle)="toggleTheme()"
      (languageChange)="setLanguage($event)" />

    <main class="workspace__content">
      <section class="workspace__hero">
        <div class="workspace__hero-copy">
          <p class="workspace__eyebrow">{{ 'admin.eyebrow' | translate }}</p>
          <h1>{{ 'admin.title' | translate }}</h1>
          <p class="workspace__copy">
            {{ 'admin.copy' | translate }}
          </p>
        </div>
      </section>

      <section class="panel">
        <div class="panel__toolbar">
          <span class="panel__tab panel__tab--active">{{ 'admin.table.panelLabel' | translate }}</span>
          <button type="button" class="panel__action" (click)="openModal()">
            {{ 'admin.actions.addUser' | translate }}
          </button>
        </div>

        <div class="user-table-wrap">
          @if (errorMessage) {
          <p class="panel__status panel__status--error">{{ errorMessage }}</p>
          }

          @if (isLoading) {
          <p class="panel__status">Loading users...</p>
          }

          <table class="user-table">
            <thead>
              <tr>
                <th>{{ 'admin.table.uco' | translate }}</th>
                <th>{{ 'admin.table.role' | translate }}</th>
                <th>{{ 'admin.table.created' | translate }}</th>
                <th>{{ 'admin.table.updated' | translate }}</th>
                <th>{{ 'admin.table.actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (user of users; track user.id) {
              <tr>
                <td>{{ user.uco }}</td>
                <td>
                  <span class="role-badge">{{ user.role }}</span>
                </td>
                <td>{{ formatUtc(user.createdAtUtc) }}</td>
                <td>{{ formatUtc(user.updatedAtUtc) }}</td>
                <td>
                  <div class="action-buttons">
                    <button
                      type="button"
                      class="action-icon-btn"
                      (click)="openEditModal(user)"
                      [attr.aria-label]="'Edit user ' + user.uco">
                      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                        <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75ZM20.71 7.04a1 1 0 0 0 0-1.41L18.37 3.29a1 1 0 0 0-1.41 0L15.13 5.12l3.75 3.75Z" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="action-icon-btn action-icon-btn--danger"
                      (click)="deleteUser(user)"
                      [disabled]="deletingUco === user.uco"
                      [attr.aria-label]="'Delete user ' + user.uco">
                      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                        <path fill="currentColor" d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 6h2v8h-2V9Zm4 0h2v8h-2V9ZM7 9h2v8H7V9Zm-1 12a2 2 0 0 1-2-2V8h16v11a2 2 0 0 1-2 2H6Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              }

              @if (!isLoading && users.length === 0) {
              <tr>
                <td class="user-table__empty" colspan="5">No users found.</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    </main>

    <app-footer [darkMode]="darkMode()" />
  </div>

  @if (modalOpen) {
  <div class="modal-backdrop" (click)="closeModal()">
    <section class="modal-card" (click)="$event.stopPropagation()" [class.modal-card--dark]="darkMode()">
      <div class="modal-card__header">
        <div>
          <p>{{ (isEditing() ? 'admin.modal.editEyebrow' : 'admin.modal.eyebrow') | translate }}</p>
          <h2>{{ (isEditing() ? 'admin.modal.editTitle' : 'admin.modal.title') | translate }}</h2>
        </div>
        <button type="button" class="modal-card__close" (click)="closeModal()" aria-label="Close dialog">
          <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
            <path fill="currentColor"
              d="m18.3 5.71-1.41-1.41L12 9.17 7.11 4.29 5.7 5.71 10.59 10.6 5.7 15.49l1.41 1.41L12 12.01l4.89 4.89 1.41-1.41-4.89-4.89Z" />
          </svg>
        </button>
      </div>

      <label class="modal-card__field">
        <span>{{ 'admin.modal.ucoLabel' | translate }}</span>
        <input type="text" [(ngModel)]="newUco" [ngModelOptions]="{ standalone: true }"
          [readonly]="isEditing()"
          [placeholder]="'admin.modal.ucoPlaceholder' | translate" />
      </label>

      <label class="modal-card__field">
        <span>{{ 'admin.modal.roleLabel' | translate }}</span>
        <div class="modal-card__select" clickOutside (clickOutside)="closeRoleMenu()">
          <button
            type="button"
            class="modal-card__select-trigger"
            [attr.aria-expanded]="roleMenuOpen"
            aria-haspopup="listbox"
            (click)="toggleRoleMenu()">
            <span>{{ newRole }}</span>
          </button>

          @if (roleMenuOpen) {
            <div class="modal-card__dropdown" role="listbox" aria-label="Role options">
              @for (role of roleOptions; track role) {
                <button type="button" class="modal-card__dropdown-item" (click)="applyRoleOption(role)">
                  {{ role }}
                </button>
              }
            </div>
          }
        </div>
      </label>

      <div class="modal-card__actions">
        <button type="button" class="modal-card__btn modal-card__btn--secondary" (click)="closeModal()">
          {{ 'admin.actions.cancel' | translate }}
        </button>
        <button type="button" class="modal-card__btn modal-card__btn--primary" (click)="saveUser()"
          [disabled]="isSaving">
          {{ isSaving ? 'Saving...' : ((isEditing() ? 'admin.actions.save' : 'admin.actions.add') | translate) }}
        </button>
      </div>
    </section>
  </div>
  }
</section>
